import * as ExcelJs from "exceljs";

export const ExportXcl = {
    methods:{
        async exportToExcel(header, data, filename){
            const options = {
                filename: filename + '.xlsx'
            }

            //Init Workbook
            const workbook = new ExcelJs.Workbook(options);
            const worksheet = workbook.addWorksheet(filename);

            worksheet.columns = header;

            //Setting font size and bold for header
            worksheet.getRow(1).font = {
                bold: true
            };

            //Insert data row to excel the data key will follow header key
            for (let index = 0; index < data.length; index++) {
                worksheet.addRow(data[index])
            }

            //Export Excel to Base64
            const base64 = Buffer.from(await         

            workbook.xlsx.writeBuffer()).toString(
                'base64'
            )

            // Download File
            const a = document.createElement('a')
            a.href = 'data:application/xlsx;base64,' + base64 
            a.download = `${filename}.xlsx` // File name Here
            a.click()
        }
    }
}